import {
  ChangeDetectorRef,
  Component,
  inject,
  Injectable,
  input,
  model,
  OnInit, QueryList,
  Signal,
  signal,
  ViewChild, ViewChildren, WritableSignal
} from '@angular/core';
import {ActivatedRoute, NavigationEnd, Router, RouterOutlet} from '@angular/router';
import { NgClass } from '@angular/common';
import { HeaderComponent } from 'ncp-lib';
import { FooterComponent } from 'ncp-lib';
import { AsideComponent } from './components/aside/aside.component';
import {UntilDestroy, untilDestroyed} from '@ngneat/until-destroy';
import { ToastService } from '@core/services/toast.service';
import { ToastComponent } from '@shared/components/toast/toast.component';
import {NgbInputDatepicker, NgbToast} from '@ng-bootstrap/ng-bootstrap';
import {Profile} from '@core/interfaces';
import {CyloginService, Roles} from '@auth';
import {browserRefresh} from '@app/app';
import {DateComponent, FormComponent, ModalComponent, ModalOptions} from '@shared/components';
import {DropdownComponent} from '@shared/components/dropdown/dropdown.component';
import {FormGroup, FormsModule, ReactiveFormsModule} from '@angular/forms';
import {ModalTypes} from '@core/enums';
import {environment} from '@env/environment';
import {PROJECTS} from '@core/constants';
import {Token} from '@core/classes/patient/token';
import {PatientSession} from '@core/classes/other/patient-session';
import {TranslateService} from '@ngx-translate/core';
import {BreadcrumbComponent} from '@shared/components/breadcrumb/breadcrumb.component';

@Injectable({
  providedIn: 'root',
})
@UntilDestroy()
@Component({
  selector: 'ncp-shell',
  imports: [
    [NgClass, RouterOutlet, HeaderComponent, FooterComponent, AsideComponent, ToastComponent],
    FormsModule,
    ModalComponent,
    ReactiveFormsModule,
    HeaderComponent,
  ],
  templateUrl: './shell.component.html',
  styleUrl: './shell.component.scss',
})
export class ShellComponent implements OnInit {
  @ViewChild('modal') public mod!: ModalComponent;
  protected readonly router = inject(Router);
  private cdref = inject(ChangeDetectorRef);
  private cyLoginService = inject(CyloginService);
  protected route = inject(ActivatedRoute);
  protected readonly toastService = inject(ToastService);
  private readonly translate = inject(TranslateService);
  protected translations = this.translate.instant('common');
  isSidebarActive = false;
  hasAside = false;
  currentUrl: string = '';
  _isLoggedIn = signal(
    (sessionStorage.getItem('profile') != null &&
    sessionStorage.getItem('profile') != undefined) ||
    (sessionStorage.getItem('patient') != null &&
    sessionStorage.getItem('patient') != undefined)
  );
  modCallback = signal(() => { this.openModal() });

  profile = JSON.parse(sessionStorage.getItem('profile')!) as Profile;
  patient = JSON.parse(sessionStorage.getItem('patient')!) as PatientSession;

  protected flexClass = this.router.url === '/eu/gr/patient' || this.router.url === '/cy/patient' || this.router.url === '/cy' || this.router.url === '/' || !this.profile;
  protected justifyClass= this.router.url === '/eu' || this.router.url === '/cy' || this.router.url === '/' || !this.profile;

  protected modOptions = model<ModalOptions>(
    new ModalOptions({
      id: 'modal',
      type: ModalTypes.info,
      title: 'user_profile',
      options: {
        animation: true,
        size: 'lg',
        fullscreen: "md",
      },
    })
  );

  set isLoggedIn(isLoggingIn: boolean) {
    this._isLoggedIn.set(isLoggingIn);
  }

  get isLoggedIn() {
    return this._isLoggedIn();
  }

  ngOnInit(): void {
    if(this.profile || this.patient?.token) {
      this.cyLoginService.isAuthenticated().subscribe((isAuthenticated) => {
        if (isAuthenticated) {
          this.isLoggedIn = true;
          this.cdref.detectChanges();
          console.log('is logged in first IF', this.isLoggedIn)
        }
      });
    }

    this.route.queryParamMap.subscribe((params) => {
      const success = params.get('s');
      if (params.has('s') && params.get('s') === 'true') {
        this.isLoggedIn = true;
        console.log('is logged in second if IF', this.isLoggedIn)
      }
    });

    const routerEvents = this.router.events.subscribe((event) => {

      if (event instanceof NavigationEnd) {
        console.log('shell NavigationEnd', event.url);
        this.currentUrl = event.url;
        this.cdref.detectChanges();

      }

    });

    this.translate.onLangChange.pipe(untilDestroyed(this)).subscribe((event) => {
      this.translations = this.translate.instant('common');
    });
  }

  openModal = () => {
    this.profile = JSON.parse(sessionStorage.getItem('profile')!) as Profile;
    this.mod.open();
  }

  capitalizeFirstLetter = (sentence: string)=> {
    return sentence.split(/[ -]{1}/).map(x => x.charAt(0).toUpperCase() + x.slice(1)).join(' ');
  }

  protected readonly sessionStorage = sessionStorage;
  protected readonly signal = signal;
  protected readonly input = input;
  protected readonly environment = environment;
  protected readonly PROJECTS = PROJECTS;
  protected readonly Roles = Roles;
  protected readonly BreadcrumbComponent = BreadcrumbComponent;
}
